/**
 * @flow
 * @relayHash 44da7c6734b2fb1e79667e2479a0be4a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Elements_QueryVariables = {|
  id: string
|};
export type Elements_QueryResponse = {|
  +node: ?{|
    +name: string,
    +id: string,
    +content: string,
    +__typename: string,
    +parent: ?{|
      +id: string,
      +name: string,
      +__typename: string,
      +children: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +__typename: string,
        +children: ?$ReadOnlyArray<?{|
          +id: string,
          +name: string,
          +__typename: string,
        |}>,
      |}>,
      +parent: ?{|
        +id: string,
        +name: string,
        +__typename: string,
        +children: ?$ReadOnlyArray<?{|
          +id: string,
          +name: string,
          +__typename: string,
        |}>,
      |},
    |},
    +children: ?$ReadOnlyArray<?{|
      +id: string,
      +name: string,
      +__typename: string,
      +children: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +__typename: string,
      |}>,
    |}>,
  |}
|};
*/


/*
query Elements_Query(
  $id: ID!
) {
  node(id: $id) {
    name
    id
    content
    __typename
    parent {
      id
      name
      __typename
      children {
        id
        name
        __typename
        children {
          id
          name
          __typename
        }
      }
      parent {
        id
        name
        __typename
        children {
          id
          name
          __typename
        }
      }
    }
    children {
      id
      name
      __typename
      children {
        id
        name
        __typename
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = [
  v2,
  v1,
  v3,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "children",
    "storageKey": null,
    "args": null,
    "concreteType": null,
    "plural": true,
    "selections": [
      v2,
      v1,
      v3
    ]
  }
],
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "children",
  "storageKey": null,
  "args": null,
  "concreteType": null,
  "plural": true,
  "selections": v4
},
v6 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "node",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id",
        "type": "ID!"
      }
    ],
    "concreteType": null,
    "plural": false,
    "selections": [
      v1,
      v2,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "content",
        "args": null,
        "storageKey": null
      },
      v3,
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "parent",
        "storageKey": null,
        "args": null,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v1,
          v3,
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "parent",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": v4
          }
        ]
      },
      v5
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Elements_Query",
  "id": null,
  "text": "query Elements_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    name\n    id\n    content\n    __typename\n    parent {\n      id\n      name\n      __typename\n      children {\n        id\n        name\n        __typename\n        children {\n          id\n          name\n          __typename\n        }\n      }\n      parent {\n        id\n        name\n        __typename\n        children {\n          id\n          name\n          __typename\n        }\n      }\n    }\n    children {\n      id\n      name\n      __typename\n      children {\n        id\n        name\n        __typename\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Elements_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v6
  },
  "operation": {
    "kind": "Operation",
    "name": "Elements_Query",
    "argumentDefinitions": v0,
    "selections": v6
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c06aeb1f42d900398a3348a94f2e425e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/Pages/Elements/__generated__/Elements_Query.graphql.js